<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="입력" icon="pi pi-pencil" class="p-button-success mr-2" @click="btnAct('NEW')" :disabled="isDeleteAble" />
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <!-- <Button label="삭제" icon="pi pi-trash" class="p-button-danger mr-2" @click="btnAct('DELETE')" :disabled="!selectedCusts || !selectedCusts.length" /> -->
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="publicId" v-model="searchParams.publicId" :options ="publicCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"
                                @change="changePublicId" :disabled="isCustUser" scrollHeight="20em" :editable="true"/>
                        <label for="publicId">업체소재지</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="custNm" type="text" v-model="searchParams.custNm" :disabled="isCustUser" />
                        <label for="custNm">업체명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="status" v-model="searchParams.status" :options ="useYns" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 8rem"/>
                        <label for="status">사용여부</label>
                    </div>
                </div> 
            </template>

            <template #end>
            </template>
        </Toolbar>
        
        <DataTable id="dt" ref="dt" :value="dataList" v-model:selection="selectedCusts" dataKey="custSeq" showGridlines 
            scrollable="true" scrollHeight="75vh" class="p-datatable-sm" responsiveLayout="scroll" scrollDirection="both">
            <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false" exportFooter=" "></Column>
            <!-- <Column field="publicNm" header="업체소재지" :sortable="true"></Column> -->
            <Column field="publicId" header="소재지" style="min-width:7em; max-width:7em" :sortable="true" exportFooter=" ">
                <template #body="{data}">
                    {{(publicCodes.find(e=>e.code == data.publicId)||{codeNm:""})['codeNm']}}
                </template>
            </Column>
            <Column field="custSeq" header="업체코드" style="min-width:5em; max-width:5em" :sortable="false" exportFooter=" "></Column>
            <Column field="custNm" header="업체명" style="width:12em" :sortable="true" exportFooter=" "></Column>
            <Column field="bizNo" header="사업자번호" style="min-width:7em; max-width:7em" exportFooter=" "></Column>
            <Column field="corpNo" header="법인번호" style="min-width:9em; max-width:9em" exportFooter=" "></Column>
            <Column field="ownerNm" header="대표자명" style="min-width:8em; max-width:8em" exportFooter=" "></Column>
            <Column field="telNo1" header="전화번호" style="width:12em" exportFooter=" "></Column>
            <Column field="faxNo" header="팩스번호" style="min-width:10em; max-width:10em" exportFooter=" "></Column>
            <Column field="email" header="이메일" style="min-width:14em; max-width:14em" exportFooter=" "></Column>
            <Column field="ipAddress" header="IP주소" style="min-width:9em; max-width:9em" exportFooter=" "></Column>
            <Column field="driverCnt" header="운전자수" style="min-width:5em; max-width:5em" exportFooter=" "></Column>
            <Column field="status" header="사용여부"  style="min-width:5em; max-width:5em" exportFooter=" ">
                <template #body="{data}">
                    {{(useYns.find(e=>e.code == data.status)||{codeNm:""})['codeNm']}}
                </template>
            </Column>
            <!-- 
            <Column field="custNo" header="거래처번호" :sortable="true"></Column>
            <Column field="custCls1" header="거래처분류1" :sortable="true"></Column>
            <Column field="custCls2" header="거래처분류2" :sortable="true"></Column> 
            <Column field="postNo" header="우편번호"></Column>
            <Column field="addr" header="주소"></Column>
            <Column field="addr1" header="상세주소"></Column>
            <Column field="homePage" header="홈페이지"></Column>
            <Column field="bizCond" header="업태"></Column>
            <Column field="bizType" header="업종"></Column>
            <Column field="custKind" header="거래처종류"></Column>
            <Column field="ssdGrade" header="보조금등급(구분)"></Column>
            <Column field="localYn" header="관내여부"></Column>
            -->
            <Column :exportable="false" style="min-width:7em; max-width:7em" exportFooter=" ">
                <template #body="slotProps">
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-success m-2" @click="rowBtnAct('EDIT',slotProps.data)" />
                    <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="rowBtnAct('DELETE',slotProps.data)" :disabled="isDeleteAble"/>
                </template>
            </Column>
        </DataTable>

        <Dialog v-model:visible="custDialog" :style="{width: '800px'}" v-bind:header="dialogHeader" :modal="true" class="p-fluid">
            <form class="p-fluid">
                <div class="p-field grid">
                    <!-- <div class="col">
                        <label for="custSeq" class="col-fixed" style="width:100px">업체코드</label>
                        <InputText id="custSeq" v-model.trim="selectedCust.custSeq" autofocus required="true" :disabled="selectedCust.insDt" :class="{'invalid': submitted && !selectedCust.custSeq }"/>
                        <small class="p-error" v-if="submitted && !selectedCust.custSeq">업체코드는 필수항목입니다.</small>
                    </div> -->
                    <div class="col">
                        <label for="custNm" class="col-fixed" style="width:100px">업체명</label>
                        <InputText id="custNm" v-model.trim="selectedCust.custNm" :disabled="selectedCust.insDt" :class="{'invalid': submitted && !selectedCust.custNm }"/>
                        <small class="p-error" v-if="submitted && !selectedCust.custNm">업체명은 필수항목입니다.</small>
                    </div>
                    <div class="col">
                        <label>소재지</label>
                        <Dropdown id="publicId" v-model="selectedCust.publicId" :options ="publicCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"
                                @change="changePublicId" :disabled="isCustUser"/>
                        <small class="p-error" v-if="submitted && !selectedCust.publicId">소재지는 필수항목입니다.</small>
                    </div>
                </div>
                <div class="p-field grid">
                    <div class="col">
                        <label>대표자명</label>
                        <InputText v-model.trim="selectedCust.ownerNm" />
                    </div>
                    <div class="p-field-radiobutton col-6">
                        <label for="status">사용여부</label>
                        <Dropdown id="status" v-model="selectedCust.status" :options ="useYns" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 8rem" />
                    </div>
                </div>
                <div class="p-field grid">
                    <div class="col">
                        <label>사업자번호</label>
                        <InputMask id="bizNo" mask="999-99-99999" v-model="selectedCust.bizNo" placeholder="999-99-99999" />
                    </div>
                    <div class="col">
                        <label>법인번호</label>
                        <InputMask id="corpNo" mask="999999-9999999" v-model="selectedCust.corpNo" placeholder="999999-9999999" />
                    </div>
                </div>
                <div class="p-field grid">
                    <div class="col">
                        <label>업태</label>
                        <InputText v-model.trim="selectedCust.bizCond" />
                    </div>
                    <div class="col">
                        <label>업종</label>
                        <InputText v-model.trim="selectedCust.bizType" />
                    </div>
                </div>
                <div class="p-field grid">
                    <div class="col">
                        <label>대표전화</label>
                        <InputText v-model.trim="selectedCust.telNo1" />
                    </div>
                    <div class="col">
                        <label>전화번호</label>
                        <InputText v-model.trim="selectedCust.telNo2" />
                    </div>
                </div>
                 <div class="p-field grid">
                    <div class="col">
                        <label>팩스번호</label>
                        <InputText v-model.trim="selectedCust.faxNo" />
                    </div>
                    <div class="col">
                        <label>이메일</label>
                        <InputText v-model.trim="selectedCust.email" />
                    </div>
                </div>
                <div class="p-field grid">
                    <div class="col">
                        <label>우편번호</label>
                        <InputText v-model.trim="selectedCust.postNo" />
                    </div>
                    <div class="col">
                        <label>IP주소</label>
                        <InputText v-model.trim="selectedCust.ipAddress" />
                    </div>
                </div>
                <div class="p-field grid">
                    <div class="col">
                        <label>주소</label>
                        <InputText v-model.trim="selectedCust.addr" />
                    </div>
                    <div class="col">
                        <label>상세주소</label>
                        <InputText v-model.trim="selectedCust.addr1" />
                    </div>
                </div>
                <div class="p-field grid">
                    <div class="col">
                        <label>운전자수</label>
                        <InputText v-model.trim="selectedCust.driverCnt" />
                    </div>
                    <div class="col">
                        <label>비고</label>
                    <Textarea v-model="selectedCust.remark" rows="1" maxlength="100"/>
                    </div>
                </div>

                <DataTable :value="custAreas" dataKey="rowNo" 
                    selectionMode="single" v-model:selection="selectedCustArea" showGridlines="true"
                    editMode="row" v-model:editingRows="editingRows2" rowIndexVar="rowIndex" removableSort 
                    @rowEditInit="onRowEditInit2"  @rowEditCancel="onRowEditCancel2" @rowEditSave="onRowEditSave2"
                    class="p-datatable-sm virtualscroll table-con"  responsiveLayout="scroll">
                    <template #header>
                        <div class="table-header">
                            관할 및 영역분류
                            <Button icon="pi pi-plus" @click="rowBtnAct2('NEW')" :disabled="selectedCust.insDt == null" />
                        </div>
                    </template>
                    <!--<Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>-->
                    <Column field="rowNo" header="No" style="min-width:2em; max-width:2em"></Column>
                    <Column field="publicSeq" header="*관할행정구역">
                        <template #body="{data}">
                            {{(publicCodes.find(e=>e.code == data.publicSeq)||{codeNm:""})['codeNm']}}
                        </template>
                        <template #editor="{ data, field }">
                            <Dropdown id="publicSeq" v-model="data[field]" :options ="publicCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem" :disabled="data.insDt"/>
                        </template>
                    </Column>
                    <Column field="areaSeq" header="*영역분류">
                        <template #body="{data}">
                            {{(areaTags.find(e=>e.code == data.areaSeq)||{codeNm:""})['codeNm']}}
                        </template>
                        <template #editor="{ data, field }">
                            <Dropdown id="areaTag" v-model="data[field]" :options ="areaTags" optionLabel="codeNm" optionValue="code" :showClear="true" :editable="true" style="width: 8rem" :disabled="data.insDt"/>
                        </template>
                    </Column>
                    <Column :rowEditor="true" style="min-width:6rem; max-width:6rem" bodyStyle="text-align:center"></Column>
                    <Column :exportable="false" style="min-width:3em; max-width:3em">
                        <template #body="slotProps">
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="rowBtnAct2('DELETE',slotProps.data)" :disabled="isDeleteAble"/>
                        </template>
                    </Column>
                </DataTable>
            </form>
            <template #footer>
                <Button label="취소" icon="pi pi-times" class="p-button-text" @click="dialogBtnAct('CANCEL')"/>
                <Button type="submit" label="저장" icon="pi pi-check" class="p-button-text" @click="dialogBtnAct('SAVE')" />
            </template>
        </Dialog>
    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from "primevue/useconfirm";
import CodeService from '@/service/cm/CodeService';
import CustService from '@/service/ma/CustService';
import CustAreaService from '@/service/ma/CustAreaService';
import JsUtils from '@/utilities/JsUtils';

export default {
    setup() {
        onMounted( async () => {
            searchParams.compSeq = 1;

           // 로그인한 사용자 정보를 얻어온다
            var user = JSON.parse(localStorage.getItem("user"));
            if(user != null && user.username != null) {
                searchParams.compSeq = user.compSeq;    // 법인코드
                if(user.publicId != null && user.publicId != '' && (user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr')) {
                    searchParams.publicId = user.publicId;  // 업체소재지
                    searchParams.custNm = user.custNm;
                    isDeleteAble.value = true;  
                    // 업체 목록을 얻어온다
                    await custService.getCodeList(searchParams).then(data => {
                        custCodes.value = data;
                        // 업체 목록에서 사용자가 속한 업체를 선택된 상태로 만든다
                        searchParams.corpId = user.custSeq;
                         if(user.userGbCd != null) {
                            // 업체사용자 또는 업체관리자인 경우, 자신이 속한 업체만 볼수 있게 한다
                            if(user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr') {
                                isCustUser.value = true;
                                isDeleteAble.value = true;    
                                btnAct('SEARCH');
                            }
                            // 시군구담당자인 경우
                            if(user.userGbCd == 'ct_mngr') {
                                searchParams.ctrPublicId = user.publicId;
                            }
                        }  
                    });
                }
            }

			codeService.getCodeList({ compSeq:1, upCode:'_public_id'}).then(data=> publicCodes.value = data);  // 관할행정지역 코드
            codeService.getCodeList({ compSeq:1, upCode:'_custstatus'}).then(data=> useYns.value = data);  // 거래처사용여부 코드            
            codeService.getCodeList({ compSeq:1, upCode:'_area_tag'}).then(data=> areaTags.value = data);  // 영역분류 코드
        })
        const isDeleteAble = ref(false);
        const isCustUser = ref(false);
		const codeService = new CodeService();
        const custService = new CustService();
        const custAreaService = new CustAreaService();
        const searchParams = reactive({publicId:null,custNm:null,status:null});
        const toast = useToast();
        const confirm = useConfirm();
        const custDialog = ref(false);
        const submitted = ref(false);
        const dialogHeader = ref('');
        const newFlag = ref(false);
        const dataList = ref([]);
		const selectedCusts = ref([]);
		const selectedCust = ref({});
        const publicCodes = ref([]);
        const areaTags = ref([]);
        const custCodes = ref([]);
        const custAreas = ref([]);
        const selectedCustArea = ref();
        const editingRows2 = ref([]);
        const originalRows2 = ref({});
        const useYns = ref([]);
        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH":
                        searchParamss();
                    break;
                case "DELETE":
                        confirmDeleteList();
                    break;
                case "NEW":
                        openNewDialog();
                    break;
                default:
            }
        }

        const rowBtnAct = (_act, cust)=>
        {
            switch(_act)
            {
                case "EDIT":
                    openEditDialog(cust)
                    break;
                case "DELETE":
                    confirmDeleteOne(cust);
                    break;
                default:
                    break;
            }
        }

        const rowBtnAct2 = (_act, custArea)=>
        {
            switch(_act)
            {
                case "NEW":
                    addNewItem2();    
                    break;
                case "DELETE":
                    confirmDeleteOne2(custArea);
                    break;    
                default:
                    break;
            }
        }

        const dialogBtnAct = (_act)=>
        {
            switch(_act)
            {
                case "CANCEL":
                    hideDialog();
                    break;
                case "SAVE":
                    saveData();
                    break;
                default:
                    break;
            }
        }

        const searchParamss = () => {
            custService.getList(searchParams).then(data => {
                dataList.value = data;
            });
			return;
        }

        const changePublicId= () => {
            custCodes.value = [];
            // 현재 선택된 업체소재지로 업체 목록을 가져와서 업체명 Dropdown 목록에 표시한다
            custService.getCodeList(searchParams).then(data => {
                custCodes.value = data;
            });
        }
		
        const openNewDialog = () => {
            newFlag.value = true;
            selectedCust.value = {compSeq:searchParams.compSeq, status:'5401'}; // 5401 사용
            submitted.value = false;
            custDialog.value = true;
            dialogHeader.value = '업체 등록';

            custAreas.value = [];
            selectedCustArea.value = {};
        };
        
        const openEditDialog = (cust) => { //수정 선택
            newFlag.value = false;
            editingRows2.value = [];
            Object.assign(selectedCust.value, cust);
            selectedCust.value.status = String(selectedCust.value.status);  // 숫자를 문자열로 변환한다
			custDialog.value = true;	
            dialogHeader.value = '업체 수정';		

            custAreas.value = [];
            selectedCustArea.value = {};

            searchParamsAreas();
        };

        const hideDialog = () => {
            custDialog.value = false;
            submitted.value = false;
        };

        const saveData = () => {
            if(!JsUtils.checkUndefineColumns(selectedCust.value,["compSeq","custNm"])){
                submitted.value = true;
                return;
            }

            if (newFlag.value)
            {
                // 신규 정보 추가
                custService.insertOne(selectedCust.value).then(() => {
                    // dataList.value.push(selectedCust.value);
                    toast.add({severity:'success', summary: '성공', detail: '등록되었습니다', life: 3000});

                    custDialog.value = false;
                    selectedCust.value = {};
                    btnAct('SEARCH');
                })
                .catch(error => {
                        if (error.response) {
                            toast.add({severity:'error', summary: '등록 오류', detail: error.response.data.message, life: 3000});
                        } else if (error.request) {
                            toast.add({severity:'error', summary: '등록 오류', detail: error.request.data, life: 3000});	
                        } else {
                            toast.add({severity:'error', summary: '등록 오류', detail: error.message, life: 3000});	
                        }
                    });
            }
            else{ // 기존 정보 업데이트
                custService.updateOne(selectedCust.value)
                    .then(() => {
                        const _index = dataList.value.findIndex(cust => cust.username == selectedCust.value.username);
                        dataList.value[_index] = selectedCust.value;
                        toast.add({severity:'success', summary: '성공', detail: '저장 되었습니다', life: 3000});

                        custDialog.value = false;
                        selectedCust.value = {};
                        btnAct('SEARCH');
                    })
                    .catch(error => {
                        if (error.response) {
                            toast.add({severity:'error', summary: '저장 오류1', detail: error.response.data.message, life: 3000});
                        } else if (error.request) {
                            toast.add({severity:'error', summary: '저장 오류2', detail: error.request.data, life: 3000});	
                        } else {
                            toast.add({severity:'error', summary: '저장 오류3', detail: error.message, life: 3000});	
                        }
                    });
            }
        };

        const confirmDeleteOne = (cust) =>{
            confirm.require({
                message:`거래처(${cust.custNm})를 삭제하시겠습니까?`,
                header: '거래처 삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deleteOne(cust);
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        const confirmDeleteList = () =>{
            confirm.require({
                message:'선택된 거래처(들)을 삭제하시겠습니까?',
                header: '거래처 삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deleteList();                    
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        const deleteOne = (cust) => {
            custService.deleteOne(cust.compSeq, cust.custSeq)
                .then(() => {                    
                    toast.add({severity:'success', summary: '성공', detail: '삭제 되었습니다', life: 3000});
                    btnAct('SEARCH');
                })
                .catch(error => {
                    if (error.response.data.code == 'C004'){
                        toast.add({severity:'error', summary: '삭제 오류', detail: '삭제 하시려는 아이디는 현재 다른 곳에서 사용중인 상태여서 삭제를 할 수 없습니다.', life: 3000});
                    } else if (error.response) {
                        toast.add({severity:'error', summary: '삭제 오류', detail: error.response.data.message, life: 3000});
                    } else if (error.request) {
                        toast.add({severity:'error', summary: '삭제 오류', detail: error.request.data, life: 3000});	
                    } else {
                        toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                    }
                });
        };
        
        const deleteList = () => {
            custService.deleteList(selectedCusts.value)
                .then(() => {                    
                    selectedCusts.value = [];
                    toast.add({severity:'success', summary: '성공', detail: '선택된 거래처(들)이 삭제되었습니다', life: 3000});
                    btnAct('SEARCH');
                })
                .catch(error => {
                    if (error.response.data.code == 'C004'){
                        toast.add({severity:'error', summary: '삭제 오류', detail: '삭제 하시려는 아이디는 현재 다른 곳에서 사용중인 상태여서 삭제를 할 수 없습니다.', life: 3000});
                    } else if (error.response) {
                        toast.add({severity:'error', summary: '삭제 오류', detail: error.response.data.message, life: 3000});
                    } else if (error.request) {
                        toast.add({severity:'error', summary: '삭제 오류', detail: error.request.data, life: 3000});	
                    } else {
                        toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                    }
                });
        };


        /**
         * 선택된 거래처의 관할 및 영역분류 목록을 조회한다
         */
        const searchParamsAreas = () => {            
            const custArea = {compSeq: selectedCust.value.compSeq, custSeq: selectedCust.value.custSeq};
            custAreas.value = [];

            custAreaService.getList(custArea).then(data => {
                custAreas.value = data;
            });
        };

        /**
         * 관할및영역분류 목록에 신규 행을 추가한다
         */
        const addNewItem2 = () => {
            if(selectedCust.value == null || selectedCust.value.custSeq == null) {
                toast.add({serverity:'warn', summary: '확인', detail: '거래처 목록에서 거래처를 선택하세요', life: 3000});
                return;
            }

            // 이미 편집중인 row가 있으면 취소한다 - 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows2.value.length > 0) {
                return;
            }

            var _ = require('lodash');
            const lastRow = _.maxBy(custAreas.value, 'rowNo'); // 마지막 순번
            let lastRowNo = 0;
            if(lastRow != null && lastRow != undefined) {
                lastRowNo = lastRow.rowNo;
            }

            var newCode = {compSeq: selectedCust.value.compSeq, custSeq: selectedCust.value.custSeq, rowNo: Number(lastRowNo) + 1};

            if(custAreas.value.length > 0) {
                // 기존 목록 뒤에 추가한다
                custAreas.value.splice(0,0, newCode);
            }
            else {
                // 목록의 첫번째에 추가한다
                custAreas.value.push(newCode);
                //custAreas.value.unshift(newCode);
            }

            // 목록의 첫번째 row를 편집 상태로 변경한다
            editingRows2.value = [...editingRows2.value, custAreas.value[0]];    
        }

        /**
         * 관할및영영분류 다이얼로그에서 연필 아이콘 클릭 시
         */
        const onRowEditInit2 = (event) => {
            // 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows2.value.length > 1) {
                // 목록에서 마지막으로 선택한 행이 배열에서 마지막에 추가되므로 마지막으로 추가된 항목을 삭제한다
                editingRows2.value.pop();
                return;
            }

            originalRows2.value[event.index] = {...custAreas.value[event.index]};
        }

        /**
         * 관할및영영분류 다이얼로그에서 X 아이콘 클릭 시
         */
        const onRowEditCancel2 = (event) => {
            let {newData} = event;
            if(newData == null || newData.insDt == null) {  // 화면에서 신규 추가한 경우
                custAreas.value.shift(); // 배열의 맨 앞의 항목을 제거한다.
                editingRows2.value = [];
                return;
            }

            custAreas.value[event.index] = originalRows2.value[event.index];
        }   

        /**
         * rowEditor에서 V 아이콘 클릭 시
         */
        const onRowEditSave2 = (event) =>{
            let {newData, index} = event;

            if(!JsUtils.checkUndefineColumns(newData,["custSeq","publicSeq","areaSeq"])){
                // 현재 수정중인 row를  편집 전 상태로 되돌려서 화면에 표시한다
                editingRows2.value = [];    
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'거래처, 관할행정, 영역분류는 필수입력 항목입니다', life:2000});
                return;
            }

            custAreas.value[index] = newData;

            if(newData.insDt == null) {
                custAreaService.insertOne(newData).then(() => {                    
                    toast.add({severity:'success', summary: '완료', detail: '등록 완료', life: 3000});
                    searchParamsAreas();
                });
            } else {
                custAreaService.updateOne(newData).then(() => {
                    custAreas.value[index] = newData;
                    toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                });
            }
        }

        const confirmDeleteOne2 = (custArea) =>{
            confirm.require({
                message:`관할 및 영역분류(${custArea.areaSeq})를 삭제하시겠습니까?`,
                header: '관할 및 영역분류 삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    custAreaService.deleteOne(custArea.compSeq, custArea.custSeq, custArea.publicSeq, custArea.areaSeq)
                        .then(() => {          
                            searchParamsAreas();
                            toast.add({severity:'success', summary: '성공', detail: '삭제 되었습니다', life: 3000});
                        })
                        .catch(error => {
                            if (error.response.data.code == 'C004'){
                                toast.add({severity:'error', summary: '삭제 오류', detail: '삭제 하시려는 아이디는 현재 다른 곳에서 사용중인 상태여서 삭제를 할 수 없습니다.', life: 3000});
                            } else if (error.response) {
                                toast.add({severity:'error', summary: '삭제 오류', detail: error.response.data.message, life: 3000});
                            } else if (error.request) {
                                toast.add({severity:'error', summary: '삭제 오류', detail: error.request.data, life: 3000});	
                            } else {
                                toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                            }
                        });
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, dataList.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(dataList.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        return { 
            dt, dataList, selectedCusts, selectedCust, custDialog,  submitted, searchParams, publicCodes, newFlag, 
            dialogHeader, useYns, custCodes, isCustUser,           
            btnAct, rowBtnAct, dialogBtnAct, openEditDialog, downloadExcel, exportCSV, changePublicId, 
            custAreas, selectedCustArea, searchParamsAreas, rowBtnAct2, areaTags, isDeleteAble,
            addNewItem2, confirmDeleteOne2, editingRows2, originalRows2, onRowEditInit2, onRowEditCancel2, onRowEditSave2,
        }
    }
}
</script>


<style lang="scss" scoped>
.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.cust-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .cust-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
